import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './../../styles/admin/galeria.css';
import './../../styles/admin/clientes_edit.css';
import * as globals from './../../components/GlobalScripts.js';
import Admin_Galeria_Modal from './Admin_Galeria_Modal';
import { useNavigate } from 'react-router-dom';

const Admin_clientes_edit = () => {
    let path_api = localStorage.getItem('path_api');
    const { id } = useParams();
    const isNew = id === 'new';
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('generalInfo');
    const [activo, setActivo] = useState('1');
    const [email, setEmail] = useState('');
    const [nombre, setNombre] = useState('');
    const [keylogin, setKeylogin] = useState('');
    const [createAt, setCreateAt] = useState('');
    const [telefono, setTelefono] = useState('');
    const [jsonInfo, setJsonInfo] = useState({
        quest: {
            edad: '',
            objetivo: '',
            restricciones: '',
            condicionesMedicas: '',
            actividadFisica: 'moderado',
            alimentosPreferidos: '',
            alimentosEvitar: '',
            comidasDiarias: '',
            diasEntrenamiento: '3-4',
            lesion: '',
            tiempoSesion: '',
            experienciaEjercicio: 'principiante',
            objetivoEntrenamiento: ''
        },
        imagenes: [],
        dieta: {
            desayuno: ["", ""],
            comida: [""],
            cena: [""]
        },
        rutina: {
            lunes: ["", ""],
            martes: [""],
            miércoles: [""],
            jueves: [""],
            viernes: [""],
            sábado: [""],
            domingo: [""]
        }
    });

    const showSection = (section) => {
        setActiveSection(section);
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (!isNew) {
            loadCliente();
        }
    }, [isNew]);

    const loadCliente = async () => {
        globals.validateSession();
        globals.openViewCharge();
        await axios.post(`${path_api}/admin/clientes_edit.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: id
        }).then(response => {
            if (response.data.mensaje === 'success' && response.data.cliente) {
                const c = response.data.cliente;
                setEmail(c.email);
                setNombre(c.nombre);
                setKeylogin(c.keylogin);
                setCreateAt(c.createAt || '');
                const direccion = c.direccion ? JSON.parse(c.direccion) : { telefono: '' };
                setTelefono(direccion.telefono || '');
                const jsonInfoData = c.json_info
                    ? { ...jsonInfo, ...c.json_info }
                    : {
                        quest: {},
                        imagenes: [],
                        dieta: { desayuno: [], comida: [], cena: [] },
                        rutina: { lunes: ["", ""], martes: [""], miércoles: [""], jueves: [""], viernes: [""], sábado: [""], domingo: [""] }
                    };

                setJsonInfo(jsonInfoData);
                setActivo(c.activo);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se pudo cargar el cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            console.log(error);
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const saveCliente = async () => {
        if (!email || !nombre) {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Debes completar todos los campos obligatorios", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        const direccion = { email, nombre, telefono };

        await axios.post(`${path_api}/admin/clientes_edit.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: isNew ? 'new' : id,
            email,
            nombre,
            direccion,
            json_info: jsonInfo,
            activo
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Cliente guardado correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                if (isNew) {
                    navigate(`/admin/clientes/${response.data.id}`);
                }
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se pudo guardar el cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al guardar cliente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const returnPage = () => {
        navigate(`/admin/clientes`);
    };

    const handleJsonInfoChange = (section, name, value) => {
        setJsonInfo(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [name]: value
            }
        }));
    };

    const handleDeleteImage = (index) => {
        setJsonInfo(prev => ({
            ...prev,
            imagenes: prev.imagenes.filter((_, i) => i !== index)
        }));
    };

    const openModalGaleria = () => {
        setIsModalOpen(true);
    };

    const closeModalGaleria = () => {
        setIsModalOpen(false);
    };

    const handleAddImages = (selectedImages) => {
        setJsonInfo(prev => ({
            ...prev,
            imagenes: [...(prev.imagenes || []), ...selectedImages]
        }));
        setIsModalOpen(false);
    };

    const handleDietaOptionChange = (section, index, value) => {
        setJsonInfo((prev) => ({
            ...prev,
            dieta: {
                ...prev.dieta,
                [section]: prev.dieta[section].map((item, i) => (i === index ? value : item))
            }
        }));
    };

    const addDietaOption = (section) => {
        setJsonInfo((prev) => ({
            ...prev,
            dieta: {
                ...prev.dieta,
                [section]: [...prev.dieta[section], '']
            }
        }));
    };

    const removeDietaOption = (section, index) => {
        setJsonInfo((prev) => ({
            ...prev,
            dieta: {
                ...prev.dieta,
                [section]: prev.dieta[section].filter((_, i) => i !== index)
            }
        }));
    };

    const addDietaSection = (sectionName) => {
        setJsonInfo((prev) => ({
            ...prev,
            dieta: {
                ...prev.dieta,
                [sectionName]: [""]
            }
        }));
    };

    const removeDietaSection = (sectionName) => {
        setJsonInfo((prev) => {
            const { [sectionName]: _, ...rest } = prev.dieta;
            return { ...prev, dieta: rest };
        });
    };

    const renameDietaSection = (oldName, newName) => {
        setJsonInfo((prev) => {
            const keys = Object.keys(prev.dieta);
            const newOrder = keys.map((key) => (key === oldName ? newName : key));
    
            const updatedDieta = newOrder.reduce((acc, key) => {
                acc[key] = key === newName ? prev.dieta[oldName] : prev.dieta[key];
                return acc;
            }, {});
    
            return {
                ...prev,
                dieta: updatedDieta,
            };
        });
    };
    

    const moveDietaSection = (section, index, direction) => {
        const keys = Object.keys(jsonInfo.dieta);
        const newIndex = direction === 'up' ? index - 1 : index + 1;

        if (newIndex < 0 || newIndex >= keys.length) return;

        const reorderedKeys = [...keys];
        [reorderedKeys[index], reorderedKeys[newIndex]] = [reorderedKeys[newIndex], reorderedKeys[index]];

        setJsonInfo((prev) => ({
            ...prev,
            dieta: reorderedKeys.reduce((acc, key) => {
                acc[key] = prev.dieta[key];
                return acc;
            }, {})
        }));
    };

    const handleRutinaOptionChange = (day, index, value) => {
        setJsonInfo((prev) => ({
            ...prev,
            rutina: {
                ...prev.rutina,
                [day]: prev.rutina[day].map((item, i) => (i === index ? value : item)),
            },
        }));
    };

    const addRutinaOption = (day) => {
        setJsonInfo((prev) => ({
            ...prev,
            rutina: {
                ...prev.rutina,
                [day]: [...(prev.rutina[day] || []), ''],
            },
        }));
    };

    const removeRutinaOption = (day, index) => {
        setJsonInfo((prev) => ({
            ...prev,
            rutina: {
                ...prev.rutina,
                [day]: prev.rutina[day].filter((_, i) => i !== index),
            },
        }));
    };

    const renameRutinaSection = (oldName, newName) => {
        setJsonInfo((prev) => {
            const keys = Object.keys(prev.rutina);
            const newOrder = keys.map((key) => (key === oldName ? newName : key));
    
            const updatedRutina = newOrder.reduce((acc, key) => {
                acc[key] = key === newName ? prev.rutina[oldName] : prev.rutina[key];
                return acc;
            }, {});
    
            return {
                ...prev,
                rutina: updatedRutina,
            };
        });
    };
    
    

    return (
        <>
            <h2>{isNew ? 'Nuevo cliente' : `Editando cliente: ${nombre}`}</h2>

            <div className="navigation-buttons">
                <button
                    onClick={() => showSection('generalInfo')}
                    className={activeSection === 'generalInfo' ? 'activo' : ''}
                >
                    {activeSection === 'generalInfo' ? 'Información general' : 'Ir a información general'}
                </button>
                <button
                    onClick={() => showSection('gallery')}
                    className={activeSection === 'gallery' ? 'activo' : ''}
                >
                    {activeSection === 'gallery' ? 'Galería' : 'Ir a galería'}
                </button>
                <button
                    onClick={() => showSection('diet')}
                    className={activeSection === 'diet' ? 'activo' : ''}
                >
                    {activeSection === 'diet' ? 'Dieta' : 'Ir a dieta'}
                </button>
                <button
                    onClick={() => showSection('rutina')}
                    className={activeSection === 'rutina' ? 'activo' : ''}
                >
                    {activeSection === 'rutina' ? 'Rutina' : 'Ir a rutina'}
                </button>
                <button
                    onClick={() => showSection('c-diet')}
                    className={activeSection === 'c-diet' ? 'activo' : ''}
                >
                    {activeSection === 'c-diet' ? 'Cuestionario de dieta' : 'Ir a cuestionario de dieta'}
                </button>
                <button
                    onClick={() => showSection('c-training')}
                    className={activeSection === 'c-training' ? 'activo' : ''}
                >
                    {activeSection === 'c-training' ? 'Cuestionario de rutina' : 'Ir a cuestionario de rutina'}
                </button>
            </div>

            {activeSection === 'generalInfo' && (
                <div className="container-form-cliente">
                    {!isNew && (
                        <div className="form-field">
                            <label>Keylogin</label>
                            <input type="text" value={keylogin} disabled />
                        </div>
                    )}

                    <div className="form-field">
                        <label>Cliente Activo</label>
                        <select value={activo} onChange={(e) => setActivo(e.target.value)}>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </select>
                    </div>

                    <div className="form-field">
                        <label className="requiered-input">Email</label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
                    </div>

                    <div className="form-field">
                        <label className="requiered-input">Nombre</label>
                        <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
                    </div>

                    <div className="form-field">
                        <label>Teléfono</label>
                        <input type="text" value={telefono} onChange={e => setTelefono(e.target.value)} />
                    </div>

                    {!isNew && (
                        <div className="form-field">
                            <label>Fecha de Creación</label>
                            <input type="text" value={createAt} disabled />
                        </div>
                    )}

                </div>
            )}

            {activeSection === 'gallery' && (
                <div className="container-form-cliente">
                    <div className="form-field">
                        <label>Imágenes del cliente ({jsonInfo.imagenes.length})</label>
                        {jsonInfo.imagenes.length > 0 ? (
                            <div className="product-images-list">
                                {jsonInfo.imagenes.map((imgObj, idx) => (
                                    <div key={idx} className="product-image-item">
                                        <button className="delete-image-button" onClick={() => handleDeleteImage(idx)}>
                                            X
                                        </button>
                                        <img src={imgObj.url} alt={`img-${imgObj.id}`} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>No hay imágenes seleccionadas.</p>
                        )}
                        <button onClick={openModalGaleria}>Agregar Imágenes</button>
                    </div>
                </div>
            )}

            {activeSection === 'diet' && (
                <div className="container-form-cliente">
                    {Object.entries(jsonInfo.dieta).map(([section, items], index) => (
                        <div key={section} className="dieta-section">
                            <div className="dieta-header">
                                <h4 className="no-margin">{section.charAt(0).toUpperCase() + section.slice(1)}</h4>
                                <div className="dieta-controls">
                                    <button
                                        className="rename-button"
                                        onClick={() => {
                                            const newName = prompt('Nuevo nombre de la sección', section);
                                            if (newName && newName !== section) {
                                                renameDietaSection(section, newName);
                                            }
                                        }}
                                    >
                                        Renombrar
                                    </button>
                                    {index > 0 && (
                                        <button
                                            className="move-button"
                                            onClick={() => moveDietaSection(section, index, 'up')}
                                        >
                                            <svg viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22 50C22.8288 50 23.6237 49.6708 24.2097 49.0847C24.7958 48.4987 25.125 47.7038 25.125 46.875V10.6687L38.5375 24.0875C38.8281 24.3781 39.173 24.6085 39.5526 24.7658C39.9322 24.923 40.3391 25.0039 40.75 25.0039C41.1609 25.0039 41.5678 24.923 41.9474 24.7658C42.327 24.6085 42.672 24.3781 42.9625 24.0875C43.2531 23.797 43.4835 23.452 43.6408 23.0724C43.798 22.6928 43.8789 22.2859 43.8789 21.875C43.8789 21.4641 43.798 21.0572 43.6408 20.6776C43.4835 20.298 43.2531 19.953 42.9625 19.6625L24.2125 0.912499C23.9222 0.621479 23.5774 0.390585 23.1977 0.233045C22.8181 0.0755047 22.411 -0.00558662 22 -0.00558662C21.589 -0.00558662 21.1819 0.0755047 20.8023 0.233045C20.4226 0.390585 20.0778 0.621479 19.7875 0.912499L1.0375 19.6625C0.450709 20.2493 0.121052 21.0452 0.121052 21.875C0.121052 22.7048 0.450709 23.5007 1.0375 24.0875C1.62429 24.6743 2.42015 25.0039 3.25 25.0039C4.07985 25.0039 4.87571 24.6743 5.4625 24.0875L18.875 10.6687V46.875C18.875 47.7038 19.2042 48.4987 19.7903 49.0847C20.3763 49.6708 21.1712 50 22 50Z" fill="black" />
                                            </svg>
                                        </button>
                                    )}
                                    {index < Object.keys(jsonInfo.dieta).length - 1 && (
                                        <button
                                            className="move-button"
                                            onClick={() => moveDietaSection(section, index, 'down')}
                                        >
                                            <svg viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22 -0.00558496C21.1712 -0.00558496 20.3763 0.323653 19.7903 0.909704C19.2042 1.49576 18.875 2.29061 18.875 3.11942L18.875 39.3257L5.4625 25.9069C5.17195 25.6164 4.82702 25.3859 4.4474 25.2286C4.06778 25.0714 3.6609 24.9905 3.25 24.9905C2.8391 24.9905 2.43222 25.0714 2.0526 25.2286C1.67298 25.3859 1.32805 25.6164 1.0375 25.9069C0.74695 26.1975 0.516473 26.5424 0.359228 26.922C0.201984 27.3016 0.121054 27.7085 0.121054 28.1194C0.121054 28.5303 0.201984 28.9372 0.359228 29.3168C0.516473 29.6964 0.74695 30.0414 1.0375 30.3319L19.7875 49.0819C20.0778 49.3729 20.4226 49.6038 20.8023 49.7614C21.182 49.9189 21.589 50 22 50C22.411 50 22.8181 49.9189 23.1977 49.7614C23.5774 49.6038 23.9222 49.3729 24.2125 49.0819L42.9625 30.3319C43.5493 29.7451 43.879 28.9493 43.879 28.1194C43.879 27.2896 43.5493 26.4937 42.9625 25.9069C42.3757 25.3201 41.5799 24.9905 40.75 24.9905C39.9202 24.9905 39.1243 25.3201 38.5375 25.9069L25.125 39.3257L25.125 3.11942C25.125 2.29061 24.7958 1.49576 24.2097 0.909704C23.6237 0.323653 22.8288 -0.00558496 22 -0.00558496Z" fill="black" />
                                            </svg>
                                        </button>
                                    )}
                                    <button
                                        className="remove-button"
                                        onClick={() => removeDietaSection(section)}
                                    >
                                        Eliminar sección
                                    </button>
                                </div>
                            </div>
                            {items.map((item, itemIndex) => (
                                <div key={itemIndex} className="dieta-item">
                                    <textarea
                                        value={item}
                                        onChange={(e) =>
                                            handleDietaOptionChange(section, itemIndex, e.target.value)
                                        }
                                        placeholder={`Opción de ${section}`}
                                    />
                                    <button
                                        className="remove-button"
                                        onClick={() => removeDietaOption(section, itemIndex)}
                                    >
                                        <svg viewBox="0 0 24 24">
                                            <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1z" />
                                        </svg>
                                    </button>
                                </div>
                            ))}
                            <button className="add-button" onClick={() => addDietaOption(section)}>
                                Agregar opción
                            </button>
                        </div>
                    ))}
                    <button
                        className="add-button"
                        onClick={() => {
                            const sectionName = prompt('Nombre de la nueva sección');
                            if (sectionName) addDietaSection(sectionName.toLowerCase());
                        }}
                    >
                        Agregar nueva sección
                    </button>
                </div>
            )}

{activeSection === 'rutina' && (
    <div className="container-form-cliente">
        {Object.entries(jsonInfo.rutina || {}).map(([day, exercises]) => (
            <div key={day} className="rutina-day">
                <div className="rutina-header">
                    <h4 className="no-margin">
                        {day.charAt(0).toUpperCase() + day.slice(1)}
                    </h4>
                    <button
                        className="rename-button"
                        onClick={() => {
                            const newName = prompt('Nuevo nombre para esta rutina', day);
                            if (newName && newName !== day) {
                                renameRutinaSection(day, newName);
                            }
                        }}
                    >
                        Renombrar
                    </button>
                </div>
                {exercises.map((exercise, exerciseIndex) => (
                    <div key={exerciseIndex} className="rutina-item">
                        <textarea
                            value={exercise}
                            onChange={(e) => handleRutinaOptionChange(day, exerciseIndex, e.target.value)}
                            placeholder={`Ejercicio para ${day}`}
                        />
                        <button
                            className="remove-button"
                            onClick={() => removeRutinaOption(day, exerciseIndex)}
                        >
                            <svg viewBox="0 0 24 24">
                                <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1z" />
                            </svg>
                        </button>
                    </div>
                ))}
                <button
                    className="add-button"
                    onClick={() => addRutinaOption(day)}
                >
                    Agregar ejercicio
                </button>
            </div>
        ))}
    </div>
)}

            {activeSection === 'c-diet' && (
                <div className="container-form-cliente">
                    <div className="form-field">
                        <label>Edad</label>
                        <input
                            type="text"
                            name="edad"
                            value={jsonInfo.quest.edad}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Objetivo</label>
                        <input
                            type="text"
                            name="objetivo"
                            value={jsonInfo.quest.objetivo}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Restricciones</label>
                        <input
                            type="text"
                            name="restricciones"
                            value={jsonInfo.quest.restricciones}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Condiciones Médicas</label>
                        <input
                            type="text"
                            name="condicionesMedicas"
                            value={jsonInfo.quest.condicionesMedicas}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Actividad Física</label>
                        <select
                            name="actividadFisica"
                            value={jsonInfo.quest.actividadFisica}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        >
                            <option value="sedentario">Sedentario</option>
                            <option value="moderado">Moderado</option>
                            <option value="intenso">Intenso</option>
                        </select>
                    </div>
                    <div className="form-field">
                        <label>Alimentos Preferidos</label>
                        <input
                            type="text"
                            name="alimentosPreferidos"
                            value={jsonInfo.quest.alimentosPreferidos}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Alimentos a Evitar</label>
                        <input
                            type="text"
                            name="alimentosEvitar"
                            value={jsonInfo.quest.alimentosEvitar}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Comidas Diarias</label>
                        <input
                            type="text"
                            name="comidasDiarias"
                            value={jsonInfo.quest.comidasDiarias}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                </div>
            )}

            {activeSection === 'c-training' && (
                <div className="container-form-cliente">
                    <div className="form-field">
                        <label>Días de Entrenamiento</label>
                        <select
                            name="diasEntrenamiento"
                            value={jsonInfo.quest.diasEntrenamiento}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        >
                            <option value="1-2">1-2</option>
                            <option value="3-4">3-4</option>
                            <option value="5-6">5-6</option>
                            <option value="7">7</option>
                        </select>
                    </div>
                    <div className="form-field">
                        <label>Lesión</label>
                        <input
                            type="text"
                            name="lesion"
                            value={jsonInfo.quest.lesion}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Tiempo de Sesión</label>
                        <input
                            type="text"
                            name="tiempoSesion"
                            value={jsonInfo.quest.tiempoSesion}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                    <div className="form-field">
                        <label>Experiencia en Ejercicio</label>
                        <select
                            name="experienciaEjercicio"
                            value={jsonInfo.quest.experienciaEjercicio}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        >
                            <option value="principiante">Principiante</option>
                            <option value="intermedio">Intermedio</option>
                            <option value="avanzado">Avanzado</option>
                        </select>
                    </div>
                    <div className="form-field">
                        <label>Objetivo del Entrenamiento</label>
                        <input
                            type="text"
                            name="objetivoEntrenamiento"
                            value={jsonInfo.quest.objetivoEntrenamiento}
                            onChange={(e) => handleJsonInfoChange('quest', e.target.name, e.target.value)}
                        />
                    </div>
                </div>
            )}

            <div className="container-form-cliente sticky">
                <div className="actions">
                    <button onClick={returnPage} className="cancel">Regresar</button>
                    <button onClick={saveCliente}>Guardar Cliente</button>
                </div>
            </div>

            {isModalOpen && (
                <Admin_Galeria_Modal
                    isOpen={isModalOpen}
                    onClose={closeModalGaleria}
                    onAdd={handleAddImages}
                />
            )}
        </>
    );

};

export default Admin_clientes_edit;
